//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.ShipDesign.ProfileSystemBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../Features/Features.ShipDesign.EndCutBuilder.js";
import "../Features/Features.ShipDesign.OrientationDefinitionBuilder.js";
import "../Features/Features.ShipDesign.PlaneListBuilderList.js";
import "../no/NXObjectList.js";
import "../no/SelectNXObjectList.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../Features/Features.ShipDesign.ShipNamesBuilder.js";
import "../Features/Features.ShipDesign.StiffenerBySupportPathBuilder.js";
import "../Features/Features.ShipDesign.StiffenerStockBuilder.js";
import "../Weld/Weld.CharacteristicsBuilder.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
import "../no/ObjectList.js";
import "../no/Weld.js";
let d=[[[0,"ApplyFlangeSetback",1,0],[0,"ApplyWebSetback",1,0],[0,"BuildSolid",1,0],[0,"ConnectAngle",1,0],[0,"CreateSeamsAtKnuckles",1,0],[1,"CurvePathOffset",0,"Expression",0],[1,"Curves",0,"Section",0],[0,"EndCutEnd",1,0],[0,"EndCutStart",1,0],[1,"EndEndCut",0,"Features.ShipDesign.EndCutBuilder",0],[1,"FaceOffset",0,"Expression",0],[0,"KnuckleLocationTolerance",1,0],[0,"MeasureAlongMode",1,0],[0,"MountingMethod",1,0],[1,"OffsetDistance",0,"Expression",0],[1,"OffsetDistanceEnd",0,"Expression",0],[1,"OffsetDistanceStart",0,"Expression",0],[0,"OffsetNumber",1,0],[0,"OffsetPlane",1,"Plane",0],[1,"OffsetSpacing",0,"Expression",0],[1,"OffsetSpacingEnd",0,"Expression",0],[0,"OffsetSpacingMode",1,0],[1,"OffsetSpacingStart",0,"Expression",0],[1,"OrientationAngle",0,"Expression",0],[1,"OrientationDefinitionBuilder",0,"Features.ShipDesign.OrientationDefinitionBuilder",0],[0,"OrientationMethod",1,0],[0,"OrientationVector",1,"Direction",0],[1,"PlaneList",0,"Features.ShipDesign.PlaneListBuilderList",0],[1,"PlanePairList",0,"NXObjectList",0],[1,"Planes",0,"SelectNXObjectList",0],[1,"PointList",0,"NXObjectList",0],[0,"PointMethod",1,0],[1,"ProjectionDirection",0,"GeometricUtilities.ProjectionOptions",0],[0,"Reverse",1,0],[1,"ShipNames",0,"Features.ShipDesign.ShipNamesBuilder",0],[1,"ShipStructure",0,"SelectNXObjectList",0],[1,"StartEndCut",0,"Features.ShipDesign.EndCutBuilder",0],[1,"StiffenerBySupportPathData",0,"Features.ShipDesign.StiffenerBySupportPathBuilder",0],[1,"StockData",0,"Features.ShipDesign.StiffenerStockBuilder",0],[0,"SwitchSide",1,0],[0,"Type",1,0],[1,"Weld",0,"Weld.CharacteristicsBuilder",0]],[[[],"CreatePlanePairBuilder",{R_:{planePairBuilder:"Features.ShipDesign.PlanePairBuilder"}},0,0],[["boundary"],"GetStiffenerBySupportBoundaryAttachedPlate",{R_:{attachPlate:"Body"}},1,0]],[]];
SPLM.Features.ShipDesign.StiffenerSystemBuilder = class extends SPLM.Features.ShipDesign.ProfileSystemBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.StiffenerSystemBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.StiffenerSystemBuilder.Types = Object.freeze({
    "Curves" : "Curves", "Planes" : "Planes", "OffsetPlanes" : "OffsetPlanes", "Points" : "Points", "BySupport" : "BySupport"});

SPLM.Features.ShipDesign.StiffenerSystemBuilder.OffsetSpacingModes = Object.freeze({
    "Single" : "Single", "Double" : "Double"});

SPLM.Features.ShipDesign.StiffenerSystemBuilder.MeasureAlongModes = Object.freeze({
    "AlongSurfaceLength" : "AlongSurfaceLength", "NormaltoPlane" : "NormaltoPlane", "AlongSurfaceChord" : "AlongSurfaceChord"});

SPLM.Features.ShipDesign.StiffenerSystemBuilder.PointMethods = Object.freeze({
    "Planes" : "Planes", "Points" : "Points"});

SPLM.Features.ShipDesign.StiffenerSystemBuilder.EndCutTypes = Object.freeze({
    "Connected" : "Connected", "FlangeFree" : "FlangeFree", "Sniped" : "Sniped", "SnipedSquare" : "SnipedSquare", "None" : "None"});

SPLM.Features.ShipDesign.StiffenerSystemBuilder.OrientationMethods = Object.freeze({
    "FaceNormal" : "FaceNormal", "Vector" : "Vector"});

SPLM.Features.ShipDesign.StiffenerSystemBuilder.MountingMethods = Object.freeze({
    "NoOffset" : "NoOffset", "AlongWeb" : "AlongWeb", "FaceNormal" : "FaceNormal"});

export default SPLM;